import React from 'react';
import 'components/styles/side-chart.css';
import CloseIcon from 'assets/images/close';
import useSmallScreenSize from 'hooks/useSmallScreenSize';
import { ReactComponent as ForgotPasswordSVG } from 'assets/images/forgot-password-panel.svg';

const ForgotPasswordPanel = () => {
  const isSmallScreen = useSmallScreenSize();

  return (
    <>
      <div
        className={`offcanvas ${isSmallScreen ? 'offcanvas-bottom fitContent' : 'offcanvas-end'}`}
        tabIndex="-1"
        id={`${isSmallScreen ? 'offcanvasBottom' : 'offcanvasWithBackdrop'}`}
        aria-labelledby="offcanvasWithBackdropLabel">
        <div
          className="offcanvas-header"
          id={`${isSmallScreen ? 'bottomSheetHeader' : 'sideChartHeader'}`}>
          <h5 className="offcanvas-title center" id="offcanvasWithBackdropLabel">
            Forgot your password
          </h5>
          <button
            type="button"
            className="btn-close text-reset close"
            data-bs-dismiss="offcanvas"
            aria-label="Close">
            <CloseIcon width="24" height="24" color="black" />
          </button>
        </div>
        <div className={`${isSmallScreen ? 'bottomSheetBody' : 'offcanvas-body sideChartBody'}`}>
          <div className="forgotPasswordBox">
            <div className="forgotPasswordIcon">
              <ForgotPasswordSVG/>
            </div>
            <div className="forgotPasswordPanelContent">
              {'Please send an email to our support team (support@mafcarrefour.com).'}
            </div>
          </div>
        </div>
        <div className="loginGotIt">
          <button data-bs-dismiss="offcanvas">Got it!</button>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordPanel;
